import React, { Component, Fragment } from 'react';

import { Select } from 'components/input';
import { I18n, translate } from 'components/translate';
import flowRight from 'lodash/flowRight';
import isEqual from 'lodash/isEqual';
import { inject } from 'mobx-react';
import { PropTypes } from 'prop-types';

import ConfigService from '../ConfigService';

export class TemplateSelector extends Component {
  static propTypes = {
    customizationData: PropTypes.object,
    isStreamingEnabled: PropTypes.bool,
    onChange: PropTypes.func,
    t: PropTypes.func,
    value: PropTypes.object
  };

  state = {
    availableTemplates: []
  };

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.customizationData, prevProps.customizationData)) {
      this.setSelectedTemplate(this.props.customizationData);
    }
  }

  async init() {
    await this.fetchTemplates();

    this.setSelectedTemplate(this.props.customizationData);
    this.saveDefaultTemplate();
  }

  async fetchTemplates() {
    const { availableTemplates } = this.props.customizationData || {};

    const data = availableTemplates || (await ConfigService.fetchTemplates());

    let templates = this.formatTemplates(data || []);

    templates = this.translateTemplates(templates);

    this.setState({ availableTemplates: templates });
  }

  formatTemplates = (templates) =>
    templates.map((template) => this.formatTemplate(template));

  formatTemplate(template) {
    return {
      value: template.hashId || template.value,
      label: template.template,
      template: template.template
    };
  }

  translateTemplates = (templates) =>
    templates.map((item) => this.translateTemplateLabel(item));

  translateTemplateLabel(template) {
    return (
      template.label && {
        ...template,
        label: this.props.t(`general.template_label.${template.label}`)
      }
    );
  }

  setSelectedTemplate(data) {
    const { availableTemplates } = this.state;
    let selectedTemplate = ConfigService.getDefaultTemplate(
      availableTemplates || []
    );

    if (data && data.template) {
      selectedTemplate = data.template;
    }

    selectedTemplate = this.formatTemplate(selectedTemplate);
    selectedTemplate = this.translateTemplateLabel(selectedTemplate);

    const { onChange } = this.props;

    onChange && onChange(selectedTemplate);
  }

  saveDefaultTemplate() {
    const { availableTemplates } = this.state;

    const defaultTemplate =
      ConfigService.getDefaultTemplate(availableTemplates);

    ConfigService.setCustomizationData({ defaultTemplate });
  }

  render() {
    const { availableTemplates } = this.state;
    const { isStreamingEnabled, onChange, value } = this.props;

    return (
      isStreamingEnabled && (
        <Fragment>
          <label className="custom__options">
            <I18n label="general.templates" />
          </label>

          <Select
            className="template__select"
            isClearable={false}
            name="language"
            onChange={onChange}
            options={availableTemplates}
            value={value}
            data-test="customization-template-select"
          />
        </Fragment>
      )
    );
  }
}

export default flowRight(
  inject((stores) => ({
    customizationData: stores.ConfigStore.custom,
    isStreamingEnabled: stores.MembershipStore.isStreamingEnabled
  })),
  translate()
)(TemplateSelector);
